import { initializeAffiliateGTM } from "./gtm";

export interface AffiliateAnalyticsConfig {
  slug: string;
  tikTokAdsCode?: string;
  metaAdsCode?: string;
  gtmCode?: string; // novo: GTM do afiliado
}

export const initAffiliateScripts = (config: AffiliateAnalyticsConfig) => {
  // Sempre insere o GTM da Yelly por padrão (já inicializado em gtm.ts)
  // Inicializa scripts do afiliado se os códigos estiverem disponíveis
  if (config.tikTokAdsCode) {
    const scriptTikTok = document.createElement('script');
    scriptTikTok.innerHTML = `
      /* TikTok Pixel Code Start */
      !function (w, d, t) { 
        w.TiktokAnalyticsObject=t; 
        var ttq=w[t]=w[t]||[]; 
        ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookie","disableCookie","holdConsent","revokeConsent","grantConsent"];
        ttq.setAndDefer=function(t,e){t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}; 
        for(var i=0;i<ttq.methods.length;i++) ttq.setAndDefer(ttq,ttq.methods[i]);
        ttq.instance=function(t){
          var e=ttq._i[t]||[], n=0;
          for(n=0;n<ttq.methods.length;n++) ttq.setAndDefer(e,ttq.methods[n]);
          return e;
        };
        ttq.load=function(e,n){
          var r="https://analytics.tiktok.com/i18n/pixel/events.js", o=n&&n.partner;
          ttq._i=ttq._i||{}, ttq._i[e]=[], ttq._i[e]._u=r, ttq._t=ttq._t||{}, ttq._t[e]=+new Date, ttq._o=ttq._o||{}, ttq._o[e]=n||{};
          n=document.createElement("script");
          n.type="text/javascript", n.async=!0, n.src=r+"?sdkid="+e+"&lib="+t;
          e=document.getElementsByTagName("script")[0]; e.parentNode.insertBefore(n,e);
        };
        ttq.load('${config.tikTokAdsCode}', { disableAutoPageView: true });
      }(window, document, 'ttq');
      /* TikTok Pixel Code End */
    `;
    document.head.appendChild(scriptTikTok);
  }
  
  if (config.metaAdsCode) {
    const scriptMeta = document.createElement('script');
    scriptMeta.innerHTML = `
      /* Meta Pixel Code */
      !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
      n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];
      t=b.createElement(e);t.async=!0;
      t.src=v;
      s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq.disablePushState = true;
      fbq('init', '${config.metaAdsCode}');
      fbq('track', 'PageView');
      /* End Meta Pixel Code */
    `;
    document.head.appendChild(scriptMeta);

    const metaNoscript = document.createElement('noscript');
    metaNoscript.innerHTML = `
      <img height="1" width="1" style="display:none" 
      src="https://www.facebook.com/tr?id=${config.metaAdsCode}&noscript=1" 
      />
    `;
    document.body.insertBefore(metaNoscript, document.body.firstChild);
  }

  if (config.gtmCode) {
    const yellyGTM = process.env.REACT_APP_GTM_ID || '';
    const affiliateGTM = config.gtmCode;

    // Insere script atualizando o dataLayer com ambos os GTM's
    const dataLayerScript = document.createElement('script');
    dataLayerScript.innerHTML = `
      dataLayer = dataLayer || {};
      dataLayer['gtm.start'] = {
        '${yellyGTM}': true,
        '${affiliateGTM}': true
      };
    `;
    document.head.insertBefore(dataLayerScript, document.head.firstChild);

    // Insere o script do gtag.js
    initializeAffiliateGTM(affiliateGTM);
  }
};

export function trackInitCheckout() {
  // Aguarda 2 segundos para assegurar o carregamento dos scripts
  setTimeout(() => {
    // Meta Pixel
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout');
    }
    // TikTok Pixel
    if (window.ttq) {
      window.ttq.track('InitiateCheckout');
    }
  }, 2000);
}

export const trackPurchase = (params: any = {}) => {
  if (window.fbq) {
    window.fbq('track', 'Purchase', {
      value: params.value,
      currency: 'BRL',
    });
  }

  if (window.ttq) {
    window.ttq.track('Purchase', {
      value: params.value,
      currency: 'BRL',
    });
  }
};

export const trackPaymentInfoAddition = (params: any = {}) => {
  if (window.fbq) {
    window.fbq('track', 'AddPaymentInfo');
  }
  if (window.ttq) {
    window.ttq.track('AddPaymentInfo');
  }
};
